module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_Bordeaux.f6e3a9fa.png";